/**
 * USD formatting for user-facing cost displays (chat cost footer, project
 * cost widget, profile-menu «Расходы» row).
 *
 * The three surfaces previously each carried a private copy of this; new
 * call sites should import it instead of adding a fourth. Two decimals
 * (cents) matches how OpenRouter reports `aggregated.cost`.
 */
export function formatUsd(value: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number.isFinite(value) ? value : 0);
}
